import PromotionPoints from "components/Home/PromotionPoints";

const OffersPromotionDetails = () => {
  return (
    <>
      <p className={`text-navyBlue font-poppins`}>
        Promote your business with special offers!
      </p>

      <div className={`text-navyBlue font-extralight tracking-wider text-base`}>
        <p className="mb-2">Examples:</p>
        <ul className="list-disc list-outside marker:text-navyBlue marker:text-base text-navyBlue text-base ml-8 font-extralight">
          <li>25% off, up to $10</li>
          <li>$5 off orders $20+</li>
        </ul>
      </div>

      <PromotionPoints
        heading={"Perks:"}
        points={[
          'Highlighted under the prominent "Offers" filter on Discovery tab',
          "Announcement in home screen activity feed",
          "Shared with customers who have previously made a purchase with you",
        ]}
      />
    </>
  );
};

export default OffersPromotionDetails;